
import 'devextreme/data/odata/store';
import MasterDetailGrid from '@/projects/admin/account-management/account-integration-log-list/account-integration-log-master-detail';
import {accountIntegrationLogService} from '@/projects/admin/services/account-integration-log-service';
import {  useRef, useState } from "react";
import { t } from 'i18next';
import DataGridWrapper from "@/core/wrappers/data-grid-wrapper";
import { DataGrid } from 'devextreme-react';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const cellPrepared = (e:any) => {
  if (e.rowType === "data") {
      if (e.column.dataField === "lastProcessStatus" ){
       if (e.data.lastProcessStatus =="Başarısız") {
          e.cellElement.style.cssText = "color: red !important; ";        
        }
        else {
        e.cellElement.style.cssText = "color: green !important; ";        
    }    }
  }
}


function LogList() {
 const masterDataGridRef = useRef<DataGrid>(null);

   const [mainStore] = useState(() =>
       createCustomStore({
        key: ['retailerCode'],
        load: accountIntegrationLogService.getSupplierLogList,
        byKey: (key, loadOptions) => {
         },
        useDefaultSearch: true
    }));
    return (
  <DataGridWrapper
  props={{ id: 'list', ref: masterDataGridRef }}
  datasource={mainStore} 
  height={700}
  onCellPrepared={cellPrepared} 
  masterDetail={(props: any) => <MasterDetailGrid {...props} masterDataGridRef={masterDataGridRef} />}
  masterGridRef={masterDataGridRef}
  pagerVisible={true}
  remoteOperations={true}
  enableCustomToolbarContent={false}
  searchPanelVisible={true}
  columnChooser={true}
  filterVisible={true}
  headerFilterVisible={true}
  editingConfig=
                       {{
                            allowDeleting: false,
                            allowUpdating: false,
                            allowAdding:false
                        }}
  columns={[
    {
      dataField: "retailerCode",
      visible: false,
  },
    {
      dataField: 'retailerName',
      caption: t('retailer'),       
    }, 
    {
        dataField: 'lastProcessStatus',
        caption: t('last_process_status'),        
      },
      {
        dataField: 'lastProcessDate',
        caption: t('last_update_datetime'),
        dataType: 'datetime',
        format: "dd/MM/yyyy HH:mm:ss",
      },
]}
  />    
     
     );
}

export default LogList;
